import Vue from 'vue'
import VueRouter from 'vue-router'
import { t } from './i18n'

Vue.use(VueRouter)

const routes = [
  { path: '/',             component: () => import('./views/Home.vue'),         meta: { titleKey: 'titles.home', descriptionKey: 'meta.description.home', bodyClass: 'page-home' } },
  { path: '/about',        component: () => import('./views/About.vue'),        meta: { titleKey: 'titles.about', descriptionKey: 'meta.description.about', bodyClass: 'page-about' } },
  { path: '/products',      component: () => import('./views/Products.vue'),     meta: { titleKey: 'titles.products', descriptionKey: 'meta.description.products', bodyClass: '' } },
  { path: '/products/item', component: () => import('./views/ProductItem.vue'), meta: { titleKey: 'titles.productItem', descriptionKey: 'meta.description.productItem', bodyClass: '' } },
  { path: '/ep-tube',      component: () => import('./views/LandingEpTube.vue'), meta: { titleKey: 'titles.landingEp', descriptionKey: 'meta.description.landingEp', bodyClass: '' } },
  { path: '/ba-tube',      component: () => import('./views/LandingBaTube.vue'), meta: { titleKey: 'titles.landingBa', descriptionKey: 'meta.description.landingBa', bodyClass: '' } },
  { path: '/square-rect-tube', component: () => import('./views/LandingSquareRect.vue'), meta: { titleKey: 'titles.landingSquareRect', descriptionKey: 'meta.description.landingSquareRect', bodyClass: '' } },
  { path: '/applications', component: () => import('./views/Applications.vue'), meta: { titleKey: 'titles.applications', descriptionKey: 'meta.description.applications', bodyClass: '' } },
  { path: '/quality',      component: () => import('./views/Quality.vue'),      meta: { titleKey: 'titles.quality', descriptionKey: 'meta.description.quality', bodyClass: '' } },
  { path: '/news',         component: () => import('./views/News.vue'),         meta: { titleKey: 'titles.news', descriptionKey: 'meta.description.news', bodyClass: 'page-news' } },
  { path: '/contact',      component: () => import('./views/Contact.vue'),      meta: { titleKey: 'titles.contact', descriptionKey: 'meta.description.contact', bodyClass: '' } },
  { path: '/privacy',      component: () => import('./views/Privacy.vue'),      meta: { titleKey: 'titles.privacy', descriptionKey: 'meta.description.privacy', bodyClass: '' } },
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 避免对象展开（Babel 会生成依赖 Object.getOwnPropertyDescriptors 的辅助函数，IE11 无此 API）
      return {
        x: savedPosition.x,
        y: savedPosition.y,
        behavior: 'auto'
      }
    }
    if (to.hash) {
      return { selector: to.hash, behavior: 'auto' }
    }
    // 路由切页使用瞬时滚动，避免从旧页面底部“被拉到顶部”的视觉拉扯
    return { x: 0, y: 0, behavior: 'auto' }
  }
})

function setMetaByName(name, content) {
  if (typeof document === 'undefined') return
  const safeContent = String(content || '')
  let el = document.querySelector(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', safeContent)
}

function setMetaProperty(property, content) {
  if (typeof document === 'undefined') return
  const safeContent = String(content || '')
  let el = document.querySelector(`meta[property="${property}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('property', property)
    document.head.appendChild(el)
  }
  el.setAttribute('content', safeContent)
}

function setCanonical(href) {
  if (typeof document === 'undefined') return
  const safeHref = String(href || '')
  let el = document.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', safeHref)
}

// 切换页面时更新 title / description / body class
router.afterEach((to) => {
  const title = t(to.meta.titleKey || 'titles.default')
  const desc = t(to.meta.descriptionKey || 'meta.description.default')
  document.title = title
  setMetaByName('description', desc)

  const origin = (typeof window !== 'undefined' && window.location && window.location.origin)
    ? window.location.origin.replace(/\/+$/, '')
    : 'https://hzhrws.com'
  const path = (to && to.fullPath) ? to.fullPath : '/'
  const canonicalUrl = `${origin}${path}`
  setCanonical(canonicalUrl)
  setMetaProperty('og:title', title)
  setMetaProperty('og:description', desc)
  setMetaProperty('og:url', canonicalUrl)
  setMetaProperty('og:type', 'website')

  // 清除所有 page-* class，再设置当前页 class
  document.body.className = document.body.className
    .split(' ')
    .filter(function (c) {
      return c.indexOf('page-') !== 0
    })
    .join(' ')
  if (to.meta.bodyClass) {
    document.body.classList.add(to.meta.bodyClass)
  }
})

export default router
